import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  adminRedirect?: boolean; // New prop to indicate if admin users should be redirected
  patrolRedirect?: boolean; // New prop to indicate if patrol users should be redirected
}

export function ProtectedRoute({ children, adminRedirect = false, patrolRedirect = false }: ProtectedRouteProps) {
  const { isAuthenticated, user, isAdminLike } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If a banned user somehow has a session, kick them to login with message
  if (user?.is_banned) {
    return (
      <Navigate
        to="/login"
        state={{ from: location, message: 'Your account has been banned. Please contact support if you believe this is a mistake.' }}
        replace
      />
    );
  }

  // Redirect admin users to admin dashboard if this route is meant for regular users
  if (adminRedirect && isAdminLike()) {
    return <Navigate to="/admin" replace />;
  }

  // Redirect patrol users to patrol dashboard if this route is meant for regular users
  if (patrolRedirect && user?.role === 'patrol') {
    return <Navigate to="/patrol" replace />;
  }

  return <>{children}</>;
} 